import Axios from "../../src/helpers/axios";

export const getStorePublicDetails = () => {
    return Axios.get("/api/ecommerce/v1/settings/store-details");
};
